import LocationClass from './../../../../../../js/classes/Location.js'
import AppClass from './../../../../../../js/classes/App.js'

const navigationItemCatalog = document.querySelector('.navigation__item_catalog'),
navigationItemBrands = document.querySelector('.navigation__item_brands'),
mobileMenuNode = document.querySelector('.navigation__mobile-menu')

if (navigationItemCatalog) {
    navigationItemCatalog.querySelector('.navigation__link').addEventListener('click', (e) => {
        if (window.innerWidth > 1000) {
            e.preventDefault()

            navigationItemBrands.classList.remove('navigation__item_active')
            navigationItemCatalog.classList.toggle('navigation__item_active')

            document.querySelector('#navigation__catalog .navigation__blackmask').style.height = (
                document.querySelector('#workspace').offsetHeight + 
                document.querySelector('#footer').offsetHeight - 
                document.querySelector('#navigation__catalog').offsetHeight
            ) + 'px'

            return false
        }
    })

    document.querySelector('#navigation__catalog .navigation__blackmask').addEventListener('click', () => {
        navigationItemCatalog.classList.remove('navigation__item_active')
    })
}

if (navigationItemBrands) {
    if (window.innerWidth > 1000) {
        navigationItemBrands.querySelector('.navigation__link').addEventListener('click', (e) => {
            e.preventDefault()

            navigationItemCatalog.classList.remove('navigation__item_active')
            navigationItemBrands.classList.toggle('navigation__item_active')

            document.querySelector('#navigation__brands .navigation__blackmask').style.height = (
                document.querySelector('#workspace').offsetHeight + 
                document.querySelector('#footer').offsetHeight - 
                document.querySelector('#navigation__brands').offsetHeight
            ) + 'px'

            return false
        })

        document.querySelector('#navigation__brands .navigation__blackmask').addEventListener('click', () => {
            navigationItemBrands.classList.remove('navigation__item_active')
        })
    }
}

if (navigationItemCatalog && navigationItemBrands) {
    const handleNavigationClose = () => {
        navigationItemCatalog.classList.remove('navigation__item_active')
        navigationItemBrands.classList.remove('navigation__item_active')
    }

    document.querySelector('body').addEventListener('keydown', (e) => {
        if (e.which === 27) {
            handleNavigationClose()
        }
    })

    document.querySelector('#navigation__catalog-close').addEventListener('click', () => {
        handleNavigationClose()
    })

    document.querySelector('#navigation__brands-close').addEventListener('click', () => {
        handleNavigationClose()
    })
}

if (mobileMenuNode) {
    mobileMenuNode.addEventListener('click', () => {
        const navigation = document.querySelector('.navigation')

        navigation.classList.toggle('navigation_mobile')
    })
}



//Location
const navigationLocationSelectButton = document.querySelector('.navigation-tablet__location-select')

if (navigationLocationSelectButton) {
    navigationLocationSelectButton.textContent = 'Получение..'
    
    LocationClass.current((err, res) => {
        if (err) {
            navigationLocationSelectButton.textContent = 'Ошибка..'
        } else {
            if (res) {
                if (res) {
                    navigationLocationSelectButton.textContent = res.CITY
                } else {
                    navigationLocationSelectButton.textContent = 'Не определён'
                }
            } else {
                
            }
        }
    })

    navigationLocationSelectButton.addEventListener('click', () => {
        AppClass.runCallback('select_location_show', true)
    })

    AppClass.addCallback('select_location_change', (newLocation) => {
        navigationLocationSelectButton.textContent = newLocation.NAME
    })
}